var FontFamily = "OpenSans, \"Helvetica Neue\", Helvetica, Arial, sans-serif";
var FontSizeTitleHeadline = "30px";
var FontSizeTitleSection = "22px";
var FontSizeTitleSubsection = "16px";
var FontSizeDefault = "13px";
var FontSizeLabel = "11px";
var FontWeightSemibold = "600";
var FontWeightNormal = "400";
var FontWeightLight = "300";
var BorderRadiusDefault = "3px";
var BorderRadiusL = "4px";
var OverlayZIndex = "10000";
var LeftMenuResizerWidth = "6px";
var LeftMenuCollapsedWidth = "40px";
var LeftMenuExpandedWith = "220px";
var TopMenuHeight = "46px";
var FontColorDefault = "#000000";
var FontColorGray = "rgba(0, 0, 0, 0.7)";
var FontColorGrayInvert = "#A0A1A4";
var FontColorLightGray = "rgba(0, 0, 0, 0.4)";
var FontColorLightGrayInvert = "#404249";
var FontColorWhite = "#FFFFFF";
var LinkColor = "#007EFF";
var LinkColorHover = "#0058B3";
var MessageColorError = "#AE304A";
var MessageColorWarning = "#E6961E";
var MessageColorSuccess = "#60A554";
var ActionColorAdd = "#60A554";
var ActionColorAddLight = "#88BC7F";
var ActionColorDelete = "#AE304A";
var FontColorAttention = "#AE304A";
var FontColorFailed = "#AE304A";
var FontColorWarning = "#E6961E";
var FontColorSuccess = "#60A554";
var FontColorSelected = "#007EFF";
var SpaceXXL = "48px";
var SpaceXL = "32px";
var SpaceLX = "24px";
var SpaceL = "20px";
var SpaceM = "16px";
var SpaceSM = "12px";
var SpaceS = "8px";
var SpaceXS = "4px";
var ControlBorderRadiusDefault = "3px";
var ControlWidthDefault = "210px";
var ControlWidthLarge = "315px";
var ControlWidthXLarge = "420px";
var ControlWidthSmall = "140px";
var ControlHeightDefault = "24px";
var ControlHeightLarge = "28px";
var ControlHeightXLarge = "40px";
var ControlDisabledOpacity = "0.5";
var PlaceholderColorDefault = "rgba(0, 0, 0, 0.7)";
var ControlBorderColorDefault = "rgba(64, 66, 73, 0.2)";
var ControlBorderColorHover = "rgba(64, 66, 73, 0.4)";
var ControlBorderColorDisabled = "rgba(64, 66, 73, 0.2)";
var ControlBoxShadowFocusTransparent = "0 0 0 3px transparent";
var ControlBoxShadowFocusDefault = "0 0 0 3px rgba(0, 126, 255, 0.2)";
var FocusBoxShadowColor = "#60A554";
var ControlBorderColorFocusDefault = "#007EFF";
var ControlBoxShadowFocusError = "0 0 0 3px rgba(174, 48, 74, 0.4)";
var ControlBorderColorFocusError = "#AE304A";
var ControlBackgroundColorDark = "#F5F6F6";
var ControlHighlightedBoxShadowFocus = "0 0 0 3px rgba(252, 245, 219, 0.2)";
var ControlHighlightedSuccessBoxShadowFocus = "0 0 0 3px rgba(96, 165, 84, 0.2)";
var ButtonLineHeightDefault = "22px";
var ButtonColorDefault = "#000000";
var ButtonColorChecked = "#000000";
var ButtonColorDisabled = "#000000";
var ButtonBorderColorDefault = "#E2E3E4";
var ButtonBorderColorHover = "#ECECED";
var ButtonBorderColorChecked = "#E2E3E4";
var ButtonBorderColorDisabled = "#E2E3E4";
var ButtonBackgroundDefault = "#F5F6F6";
var ButtonBackgroundHover = "#ECECED";
var ButtonBackgroundChecked = "#E2E3E4";
var ButtonBackgroundActive = "#E2E3E4";
var IconsSizeDefault = "16px";
var IconsGeneralColor = "#A0A1A4";
var IconsTeamColor = "#A0A1A4";
var IconsTeamColorRevert = "#FFFFFF";
var ActionIconOpacity = 0.8;
var ListCellResizerWidth = "5px";
var ListResizableCellMargin = "5px";
var ListCollapserWidth = "16px";
var BackgroundDefault = "#FFFFFF";
var BackgroundInvert = "#000000";
var BackgroundDisabled = "#F5F6F6";
var HighlightBlockBackground = "#F5F6F6";
var HighlightBlockBorderColor = "rgba(64, 66, 73, 0.1)";
var SelectedTagBackground = "#F5F6F6";
var BackgroundStrokeHighlight = "#F9E9AE";
var ActionBackgroundHover = "#F9E9AE";
var ActionBackgroundActive = "#F1CE4A";
var ActionBackgroundSelected = "#F1CE4A";
var ActionBackgroundSystem = "#F9E9AE";
var ActionBackgroundSuccess = "#E7F2E5";
var ActionBackgroundWarning = "#FAEAD2";
var ActionBackgroundDelete = "#F3E0E4";
var DnDPlaceholderBackground = "#007EFF";
var BoxShadowS = "0 1px 2px 0 rgba(0, 0, 0, 0.24)";
var BoxShadowSM = "0 2px 4px 0 rgba(0, 0, 0, 0.16)";
var BoxShadowM = "0 1px 10px 0 rgba(0, 0, 0, 0.12)";
var BoxShadowL = "0 4px 16px 0 rgba(0, 0, 0, 0.12)";
var ZIndexBoard = 1;
var ZIndexPanel = 102;
var ZIndexOverlay = 10000;
var ZIndexModal = 10001;
var ZIndexModalPlus = 10002;

export { FontFamily, FontSizeTitleHeadline, FontSizeTitleSection, FontSizeTitleSubsection, FontSizeDefault, FontSizeLabel, FontWeightSemibold, FontWeightNormal, FontWeightLight, BorderRadiusDefault, BorderRadiusL, OverlayZIndex, LeftMenuResizerWidth, LeftMenuCollapsedWidth, LeftMenuExpandedWith, TopMenuHeight, FontColorDefault, FontColorGray, FontColorGrayInvert, FontColorLightGray, FontColorLightGrayInvert, FontColorWhite, LinkColor, LinkColorHover, MessageColorError, MessageColorWarning, MessageColorSuccess, ActionColorAdd, ActionColorAddLight, ActionColorDelete, FontColorAttention, FontColorFailed, FontColorWarning, FontColorSuccess, FontColorSelected, SpaceXXL, SpaceXL, SpaceLX, SpaceL, SpaceM, SpaceSM, SpaceS, SpaceXS, ControlBorderRadiusDefault, ControlWidthDefault, ControlWidthLarge, ControlWidthXLarge, ControlWidthSmall, ControlHeightDefault, ControlHeightLarge, ControlHeightXLarge, ControlDisabledOpacity, PlaceholderColorDefault, ControlBorderColorDefault, ControlBorderColorHover, ControlBorderColorDisabled, ControlBoxShadowFocusTransparent, ControlBoxShadowFocusDefault, FocusBoxShadowColor, ControlBorderColorFocusDefault, ControlBoxShadowFocusError, ControlBorderColorFocusError, ControlBackgroundColorDark, ControlHighlightedBoxShadowFocus, ControlHighlightedSuccessBoxShadowFocus, ButtonLineHeightDefault, ButtonColorDefault, ButtonColorChecked, ButtonColorDisabled, ButtonBorderColorDefault, ButtonBorderColorHover, ButtonBorderColorChecked, ButtonBorderColorDisabled, ButtonBackgroundDefault, ButtonBackgroundHover, ButtonBackgroundChecked, ButtonBackgroundActive, IconsSizeDefault, IconsGeneralColor, IconsTeamColor, IconsTeamColorRevert, ActionIconOpacity, ListCellResizerWidth, ListResizableCellMargin, ListCollapserWidth, BackgroundDefault, BackgroundInvert, BackgroundDisabled, HighlightBlockBackground, HighlightBlockBorderColor, SelectedTagBackground, BackgroundStrokeHighlight, ActionBackgroundHover, ActionBackgroundActive, ActionBackgroundSelected, ActionBackgroundSystem, ActionBackgroundSuccess, ActionBackgroundWarning, ActionBackgroundDelete, DnDPlaceholderBackground, BoxShadowS, BoxShadowSM, BoxShadowM, BoxShadowL, ZIndexBoard, ZIndexPanel, ZIndexOverlay, ZIndexModal, ZIndexModalPlus };
